define('AwaLabs.SearchInBanner', [
    'SearchInBanner.View'
], function AwaLabsSearchInBanner(
    SearchInBannerView
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent('Layout');
            var environment = container.getComponent('Environment');

            if (layout) {
                layout.registerView('SearchInBanner', function SearchInBannerConstructor() {
                    return new SearchInBannerView({
                        container: container,
                        config: environment.getConfig('SearchInBanner'),
                        maxLength: environment.getConfig('searchPrefs.maxLength'),
                        defaultSearchUrl: environment.getConfig('defaultSearchUrl')
                    });
                });
            }
        }
    };
});
